import type {
  GetFeedbackResponse,
  SubmitFeedbackRequest,
  SubmitFeedbackResponse,
} from "@/types";
import { ApiError } from "./errors";
import { request } from "./request";

export async function submitFeedback(
  auditId: string,
  feedback: SubmitFeedbackRequest,
): Promise<SubmitFeedbackResponse> {
  return request<SubmitFeedbackResponse>(`/audits/${auditId}/feedback`, {
    method: "POST",
    body: feedback as unknown as Record<string, unknown>,
    contentType: "json",
  });
}

export async function getFeedback(
  auditId: string,
): Promise<GetFeedbackResponse | null> {
  try {
    return await request<GetFeedbackResponse>(`/audits/${auditId}/feedback`);
  } catch (error) {
    if (error instanceof ApiError && error.status === 404) {
      return null;
    }
    throw error;
  }
}
